import { render, staticRenderFns } from "./why-choose-us.vue?vue&type=template&id=4dde7b96&"
import script from "./why-choose-us.vue?vue&type=script&lang=js&"
export * from "./why-choose-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports